import { CategoriesBySector } from '../categories-types';

export const CATEGORIES_VENUE_DATE: CategoriesBySector = {
  '': undefined,
  ANY: undefined,
  TEAM: undefined,
  ARTISTS: ['all', 'mobility', 'catering', 'accommodation', 'cargo'],
  SITE: undefined,
  PUBLIC: undefined,
};
